import styled from '@emotion/styled'
import { mergeDeepRight } from 'ramda'

export const FirstColumn = styled('div')(({ customCss = {} }) =>
  mergeDeepRight({}, customCss),
)
